import { getOperation, getRisk, fetchRisk, putRisk } from "utils/api";

//list
export const queryDisputeList = async (params) => {
  return await getRisk("/disputes", {
    ...params,
  });
};

//detail
export const queryDisputeDetail = async (disputeId, params) => {
  return await getRisk("/disputes/" + disputeId, {
    ...params,
  });
};
export const queryPayment = async (params) => {
  return await getOperation("/payment/list", {
    page: 0,
    size: 20,
    sort: "created,desc",
    ...params,
  });
};

export const queryMerchant = async (params) => {
  return await getOperation("/merchant/detail", {
    page: 0,
    size: 20,
    sort: "createdDate,desc",
    ...params,
  });
};

export const createDisputeCase = async (params) => {
  return await fetchRisk("/disputes", {
    ...params,
  });
};

export const updateDisputeCase = async (disputeId, params) => {
  return await putRisk("/disputes/" + disputeId, {
    ...params,
  });
};
